import { default as CountryLabels } from 'react-phone-number-input/locale/en';
import { getCountries } from 'react-phone-number-input';
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';
import React from 'react';

import BaseSelect from '$partials/fields/select';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/fields').PhoneInputCountrySelect}
 */
export const CountrySelect = ({ value, onChange }) => {
    const options = getCountries().map((country) => {
        return {
            label: CountryLabels?.[country],
            value: country
        };
    });

    return (
        <BaseSelect
            displayValue={value}
            name='phone-country'
            onChange={onChange}
            options={options}
            triggerClassName='phone-input--country-select'
            value={value} />
    );
};

/**
 * @type {import('$types/components/partials/fields').PhoneInput}
 */
export const PhoneInput = (props) => {
    return (
        <PhoneInputWithCountry
            international
            countryCallingCodeEditable={false}
            countrySelectComponent={CountrySelect}
            defaultCountry='GB'
            flagComponent={null}
            flags={null}
            maxLength={20}
            withCountryCallingCode={true}
            {...props} />
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PhoneInput;
